export const REPORT_LIST = [
  {
    name: 'Smooth Travel Exposure',
    url: 'smooth-travel-exposure',
    enabled: true,
  },
  {
    name: 'Smooth Travel Exposure Target setting for 2027-37 LTP',
    url: 'smooth-travel-exposure-ltp-target',
    enabled: false,
  },
];
